module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "semipolar-spinner",
    style: (_vm.spinnerStyle)
  }, _vm._l((_vm.ringsStyles), function(rs, index) {
    return _c('div', {
      key: index,
      staticClass: "ring",
      style: (rs)
    })
  }), 0)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-81954cfe", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-81954cfe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/epic-spinners/src/components/lib/SemipolarSpinner.vue
// module id = 855
// module chunks = 0